import { loadByIdExerciseAction } from '@gymaholic/packages'
import { logUtil } from 'packages/src'

/**
 * @param props
 * @param props.route
 * @param props.match
 * @param props.options
 * @return {(function(*): Promise<void>)|*}
 */
export default function loadByIdRouteExerciseAction ({
  route,
  match,
  options
}) {
  return async (dispatch) => {
    const id = match?.params?.id
    const logPrefix = `id=${id}`
    logUtil('loadByIdRouteExerciseAction').debug(`${logPrefix} [start]`)

    if (!id) {
      const debugProps = {
        route,
        match
      }
      logUtil('loadByIdRouteExerciseAction').warn(`${logPrefix} [noop] no id debugProps=`, debugProps)
      return
    }

    try {
      await dispatch(
        loadByIdExerciseAction(Number(id))
      )
    } catch (error) {
      logUtil('loadByIdRouteExerciseAction').error(`${logPrefix} error=`, error)
    }
  }
}
